export const STATE_VERSION = 3;

export interface PersistedState {
  version: number;
  [key: string]: any;
}

export function isPersistedState(obj: any): obj is PersistedState {
  return obj && typeof obj === 'object' && typeof obj.version === 'number';
}
